import React, { createContext, useContext, useState } from "react";

const DesignContext = createContext();

export const DesignProvider = ({ children }) => {
  const [selectedDesign, setSelectedDesign] = useState(null);
  const [answers, setAnswers] = useState({});
  const [name, setName] = useState("");

  const designs = [
    {
      id: 1,
      title: "Classic Floral",
      image: `${process.env.PUBLIC_URL}/assets/memo-cards/mothers-day/bg1.svg`,
    },
    {
      id: 2,
      title: "Modern Minimal",
      image: `${process.env.PUBLIC_URL}/assets/memo-cards/mothers-day/bg2.svg`,
    },
    {
      id: 3,
      title: "Vintage Charm",
      image: `${process.env.PUBLIC_URL}/assets/memo-cards/mothers-day/bg3.svg`,
    },
  ];

  return (
    <DesignContext.Provider
      value={{
        selectedDesign,
        setSelectedDesign,
        designs,
        answers,
        setAnswers,
        name,
        setName,
      }}
    >
      {children}
    </DesignContext.Provider>
  );
};

export const useDesign = () => {
  const context = useContext(DesignContext);
  if (!context) {
    throw new Error("useDesign must be used within a DesignProvider");
  }
  return context;
};
